package com.dotdrives.web.pages.drives

import com.dotdrives.controller.DriveFilters
import com.dotdrives.model.OrgMember
import com.dotdrives.model.Target
import react.FC
import react.Key
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface FilterPopoverProps : Props {
    var filters: DriveFilters
    var members: List<OrgMember>
    var targets: List<Target>
    var availableTags: List<String>
    var onChange: (DriveFilters) -> Unit
    var onClose: () -> Unit
    var matchCount: Int
}

val FilterPopover = FC<FilterPopoverProps> { props ->
    val filters = props.filters

    div {
        className = ClassName("drives-filter-popover")
        div { className = ClassName("drives-filter-popover-title"); +"Filters" }

        FilterGroup("STEWARD") {
            props.members.forEach { member ->
                FilterPill(
                    label = member.displayName,
                    active = filters.stewardUserId == member.userId,
                ) {
                    props.onChange(
                        filters.copy(
                            stewardUserId = if (filters.stewardUserId == member.userId) null else member.userId,
                        ),
                    )
                }
            }
        }

        FilterGroup("DONATION TARGET") {
            props.targets.forEach { target ->
                FilterPill(
                    label = target.name,
                    active = filters.targetId == target.id,
                ) {
                    props.onChange(filters.copy(targetId = if (filters.targetId == target.id) null else target.id))
                }
            }
        }

        FilterGroup("TAGS") {
            if (props.availableTags.isEmpty()) {
                span { className = ClassName("drives-empty-copy"); +"No tags yet" }
            }
            props.availableTags.forEach { tag ->
                FilterPill(label = tag, active = filters.tag == tag) {
                    props.onChange(filters.copy(tag = if (filters.tag == tag) null else tag))
                }
            }
        }

        FilterGroup("GIVER TYPE") {
            listOf("individual" to "Individual", "organization" to "Organization").forEach { (value, label) ->
                FilterPill(label = label, active = filters.giverType == value) {
                    props.onChange(filters.copy(giverType = if (filters.giverType == value) null else value))
                }
            }
        }

        div {
            className = ClassName("drives-filter-footer")
            button {
                type = ButtonType.buttonType
                className = ClassName("drives-filter-clear")
                onClick = { props.onChange(DriveFilters()) }
                +"Clear all"
            }
            button {
                type = ButtonType.buttonType
                className = ClassName("drives-filter-apply")
                onClick = { props.onClose() }
                +"Apply · ${props.matchCount} drives"
            }
        }
    }
}

private fun react.ChildrenBuilder.FilterGroup(label: String, content: react.ChildrenBuilder.() -> Unit) {
    div {
        className = ClassName("drives-filter-group")
        div { className = ClassName("drives-filter-group-label"); +label }
        div {
            className = ClassName("drives-filter-options")
            content()
        }
    }
}

private fun react.ChildrenBuilder.FilterPill(label: String, active: Boolean, onClick: () -> Unit) {
    button {
        key = label.unsafeCast<Key>()
        type = ButtonType.buttonType
        className = ClassName("drives-filter-pill" + if (active) " drives-filter-pill-active" else "")
        this.onClick = { onClick() }
        +label
    }
}
